import React from "react";
import "../BlockChain/Blockchain.css";
import { NavLink } from "react-router-dom";
import {
  FiArrowRight,
  FiSearch,
  FiTrendingUp,
  FiFacebook,
  FiEdit3,
  FiPieChart,
  FiGlobe,
} from "react-icons/fi";

const DigitalMarketing = () => {
  return (
    <div className="sub-service-page">
      <div className="page-bg-engine">
        <div className="theme-orb orb-primary"></div>
        <div className="theme-orb orb-secondary"></div>
      </div>
      {/* --- Section 1: Sovereign Hero --- */}
      <section className="sub-hero">
        <div className="v2-container">
          <div className="sub-hero-content">
            <div className="v3-badge">Growth Strategy</div>
            <h1 className="title-reveal">
              Neural <span className="blue-glow">Market</span> Mastery
            </h1>
            <p className="v3-hero-p-centered">
              Harnessing data science and psychological mapping to accelerate
              global visibility. We don't just market; we architect digital
              influence.
            </p>
          </div>
        </div>
      </section>

      {/* --- Section 2: Scale Reveal --- */}
      <section className="sub-content-section">
        <div className="v2-container">
          <div className="content-layout-left">
            <h2 className="v3-title">
              The Science of <span className="blue-glow">Influence</span>
            </h2>
            <p className="v3-p-text">
              Marketing is the architectural process of promoting and selling
              high-impact services. We optimize every touchpoint through
              rigorous market research and customer behavior analysis.
            </p>

            <div className="tech-stack-strip small-icons">
              {[
                "face1.avif",
                "twi.jpg",
                "lin.webp",
                "pin.png",
                "wha1.png",
                "sna.jpg",
                "ins.avif",
                "you.webp",
              ].map((img, i) => (
                <img src={`/${img}`} alt="social" key={i} />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* --- Section 3: Pillars Grid --- */}
      <section className="sub-features-section">
        <div className="v2-container">
          <div className="v3-section-head left">
            <h2 className="v3-title">
              Strategic <span className="blue-glow">Pillars</span>
            </h2>
          </div>

          <div className="feature-grid-sub">
            {[
              {
                icon: <FiSearch />,
                title: "SEO optimization",
                desc: "Technical search excellence to dominate organic rankings and visibility.",
              },
              {
                icon: <FiTrendingUp />,
                title: "Google Ads",
                desc: "Precision-targeted PPC campaigns with optimized ROI focus.",
              },
              {
                icon: <FiFacebook />,
                title: "Social Impact",
                desc: "High-engagement campaigns across Meta and emerging social layers.",
              },
              {
                icon: <FiEdit3 />,
                title: "Content Forge",
                desc: "Compelling narrative development that converts users into advocates.",
              },
              {
                icon: <FiPieChart />,
                title: "Analytics",
                desc: "Neural data-driven adjustments for absolute market capture.",
              },
              {
                icon: <FiGlobe />,
                title: "Global Reach",
                desc: "Cross-border marketing strategies for international scale.",
              },
            ].map((item, idx) => (
              <div className="feature-card-sub" key={idx}>
                <div className="f-icon-box">{item.icon}</div>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* --- Section 4: Deep Dive technical rows --- */}
      <section className="sub-platforms">
        <div className="v2-container">
          <div className="platform-row">
            <div className="platform-text">
              <h2 className="v3-title">
                Search <span className="blue-glow">Autonomy</span>
              </h2>
              <p className="v3-p-text">
                Optimize your infrastructure with SEO strategies to enhance
                visibility and attract organic high-intent traffic through
                strategic keyword implementation.
              </p>
              <NavLink to="/contactus" className="btn-secondary">
                Technical Audit <FiArrowRight />
              </NavLink>
            </div>
            <div className="platform-visual">
              <FiSearch
                style={{ fontSize: "10rem", color: "#0066ff", opacity: 0.3 }}
              />
            </div>
          </div>

          <div className="platform-row reverse">
            <div className="platform-text">
              <h2 className="v3-title">
                Social <span className="blue-glow">Presence</span>
              </h2>
              <p className="v3-p-text">
                Launch successful campaigns to reach and engage your target
                audience. We develop visually stunning creatives to grab
                institutional attention.
              </p>
              <NavLink to="/contactus" className="btn-secondary">
                Initialize Campaign <FiArrowRight />
              </NavLink>
            </div>
            <div className="platform-visual">
              <FiFacebook
                style={{ fontSize: "10rem", color: "#6366f1", opacity: 0.3 }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* --- Section 5: Universal CTA --- */}
      <section className="v3-final-cta">
        <div className="v2-container">
          <div className="v3-cta-card">
            <div className="v3-cta-content">
              <h2 className="v3-cta-title">
                Ready to scale <br />
                <span className="grad-blue">your visibility?</span>
              </h2>
              <NavLink to="/contactus" className="v3-main-btn">
                <span>Initialize Growth</span>
                <div className="btn-icon-box">
                  <FiArrowRight />
                </div>
              </NavLink>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DigitalMarketing;
